import React from 'react';
import Routes from 'routes';
import 'translations';
import { ScrollToTop } from 'components';
import { ConfigProvider } from 'antd';
import antdConfig from 'theme/antdConfig';
import { AuthContextProvider } from 'contexts/AuthContext';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Router } from 'react-router';
import { createBrowserHistory } from 'history';

export default function App() {
  const history = React.useMemo(() => createBrowserHistory(), []);

  const queryClient = React.useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retryDelay: 30 * 1000,
            retry: import.meta.env.MODE !== 'development',
          },
          mutations: {
            retry: false,
          },
        },
      }),
    [],
  );

  return (
    <QueryClientProvider client={queryClient}>
      <AuthContextProvider>
        <ConfigProvider {...antdConfig()}>
          <Router history={history}>
            <ScrollToTop />
            <Routes />
          </Router>
        </ConfigProvider>
      </AuthContextProvider>
    </QueryClientProvider>
  );
}
